module.exports = __webpack_public_path__ + "static/media/budweiser.ede6e945.png";